<template>
    <b-modal
        id="checkoutModal"
        v-model="licentaPopup"
        size="xxl"
        ok-variant="success"
        ok-title="Confirmă"
        cancel-variant="danger"
        cancel-title="Anulează"
        header-bg-variant="dark"
        body-bg-variant="dark"
        hide-footer
        hide-header
        centered
        @hide="$emit('hideTempModal');onHide($event)"
    >

        <div class="modal-body">
            <div class="modal-header">
                <div class="flex flex-column align-center">
                    <span><strong>Salut!</strong> Momentan, achiziția unei licențe nu este disponibilă</span>
                </div>
            </div>
            <p>Aplicația <strong>POC</strong>Sketch® poate fi utilizată gratuit. Nu facturăm licențe de utilizare. Momentan aplicația este dezvoltată în baza ghidului solicitantului varianta consultativă.
                Licențele vor fi disponibile după lansarea ghidului final, respectiv după actualizarea aplicației la ghidul final.
                Pentru detalii suplimentare ne poți contacta prin e-mail la <strong>office@smis.ro</strong> sau telefonic la <strong>0722.114.395</strong></p>
            <span class="title">Costuri de utilizare</span>
            <div class="plans-list flex space-between">
                <div class="plan">
                    <div class="plan-info">
                        <p><strong>Licență standard</strong></p>
                        <p class="price"><sub>Lei</sub>2700<sup>*</sup></p>
                    </div>
                    <img src="@/assets/images/sketch_new.png" alt="">
                </div>
                <div class="plan">
                    <div class="plan-info">
                        <p><strong>Licență</strong> utilizatori <strong>Smis®</strong></p>
                        <p class="price"><sub>Lei</sub>1350<sup>*</sup></p>
                        <p class="plan-info">Ești client Smis și ai achiziționat <strong>M2</strong>Manager®</p>
                    </div>
                    <img src="@/assets/images/M3/M3Pircing/m2_logo.png" alt="">
                </div>
                <div class="plan">
                    <div class="plan-info">
                        <p><strong>Licență Termene</strong></p>
                        <p class="price"><sub>Lei</sub>2200<sup>*</sup></p>
                        <p class="plan-info">Ofertă specială pentru utilizatorii <strong>Termene®</strong></p>
                    </div>
                    <img src="@/assets/images/M3/M3Pircing/termene.png" alt="">
                </div>
                <div class="plan plan-wide">
                    <div class="plan-info">
                        <p style="align-self: flex-start; text-align: left"><strong>Licență consultanți</strong></p>
                        <div class="flex space-between">
                            <div class="licenta">
                                <p class="price"><sub>Lei</sub>1900<sup>*</sup></p>
                                <p class="plan-info">2-10 proiecte</p>
                            </div>
                            <div class="licenta">
                                <p class="price"><sub>Lei</sub>1400<sup>*</sup></p>
                                <p class="plan-info">11-30 proiecte</p>
                            </div>
                            <div class="licenta">
                                <p class="price"><sub>Lei</sub>700<sup>*</sup></p>
                                <p class="plan-info">30+ proiecte</p>
                            </div>
                        </div>
                    </div>
                    <div class="flex discount-info">
                        <span>Ești firmă membră AMCOR? Trimite un e-mail la <a href="mailto:office@smis.ro" class="green-text">office@smis.ro</a>. Avem o ofertă exclusivă pentru membri. Mulțumim.</span>
                        <img src="@/assets/images/M3/M3Pircing/amcor.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import {BModal, BForm, BFormGroup, BFormInput, BButton, BIconInfoCircle} from 'bootstrap-vue';
    export default {
        components: {
            BModal,
            BForm,
            BFormGroup,
            BFormInput,
            BButton,
            BIconInfoCircle
        },
        props: {
            licentaPopup: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
            };
        },
        mounted() {
        },
        methods: {
            onHide(evt) {
                if(evt.trigger === "backdrop"){
                    evt.preventDefault();
                    this.$emit('hideTempModal')
                }
            },
        },
    };
</script>

<style>
#checkoutModal .modal-dialog .bg-dark {
    background-color: rgb(0 0 0 / 89%) !important;
    backdrop-filter: blur(1px);
    position: relative;
    max-height: 830px;
    overflow: auto;
    /* height: 85vh; */
    padding: 30px;
}
</style>

<style scoped>
#checkoutModal .modal-dialog .bg-dark {
    background-color: rgba(21, 20, 20, 0.85) !important;
    border: rgba(21, 20, 20, 0.7) !important;
    backdrop-filter: blur(7px);
    position: relative;
    max-height: 830px;
    overflow: auto;
    height: 85vh;
    padding: 30px;
}
.bg-dark{
    background-color: #000000d9;
}
.modal-body{
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 15px;
}
.modal-body >>> .modal-header span {
    font-size: 24px;
    margin-bottom: 20px;
    color: #fff;
}
.modal-body >>> .modal-header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    position: relative;
}
.modal-body p{
    color: #fff;
    text-align: center;
    margin-top: 15px;
    font-size: 15px;
}
.white-icon{
    color: #fff;
    margin-bottom: 20px;
}
.title{
    font-size: 24px;
    color: #fff;
    margin-top: 50px;
    font-weight: 400;
}
.plans-list{
    width: 100%;
}
.space-between{
    justify-content: space-between;
}
.plan{
    padding: 15px 20px;
    border: 2px solid #fff;
    border-radius: 3px;
    width: 100%;
    max-width: 230px;
    min-height: 205px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.plan img{
    max-height: 30px;
    object-fit: none;
}
.plan-wide{
    max-width: 670px;
}
.plan p{
    margin: 0;
}
.price{
    font-size: 40px !important;
}
.price sub{
    bottom: 0;
    font-size: 25px !important;
}
.price sup{
    top: -15px;
    font-size: 25px !important;
}
.plan-info{
    font-size: 13px !important;
}
.discount-info{
    font-size: 15px;
    color: #fff;
    align-items: center;
}
.discount-info span{
    font-size: 14px;
    max-width: 550px;
    text-align: left;
}
.green-text{
    color: #0a9953;
}
.green-text:hover{
    text-decoration: none;
}
</style>